/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export const GOOGLE_AREA_LEVELS = {
    "Level 1": "administrative_area_level_1",
    "Level 2": "administrative_area_level_2"
}
